module.exports = __webpack_public_path__ + "img/step05_b_stand_basic_right_bottom_cross_fix_screws.78f0af84.png";